import { render, staticRenderFns } from "./TotalAcessosMesDash.vue?vue&type=template&id=00814fa4"
import script from "./TotalAcessosMesDash.vue?vue&type=script&lang=js"
export * from "./TotalAcessosMesDash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports